import type { App } from 'vue'
import setupAuthDirective from './v-auth.directives'

export function setupDirectives(app: App) {
    setupAuthDirective(app)
}
